import { pipe, Subject } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
/**
 * Observable Cache can publish new values to subscribers
 * when an item is set, deleted or when the cache is cleared.
 */
export class ObservableMap {
    constructor() {
        this.cache = new Map();
        this.signal = new Subject();
        /** A signal with the new values of the map */
        this.values = this.signal
            .asObservable()
            .pipe(this.convertToArray(() => this.cache.values()));
        /** A signal with the new keys of the map */
        this.keys = this.signal
            .asObservable()
            .pipe(this.convertToArray(() => this.cache.keys()));
    }
    forEach(callbackfn, thisArg) {
        this.cache.forEach(callbackfn, thisArg);
    }
    set(key, value) {
        this.cache.set(key, value);
        this.publish();
    }
    get(key) {
        return this.cache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        this.publish();
        return deleted;
    }
    clear() {
        this.cache.clear();
        this.publish();
    }
    has(key) {
        return this.cache.has(key);
    }
    publish() {
        this.signal.next(undefined);
    }
    convertToArray(iterator) {
        return pipe(startWith(() => Array.from(iterator())), map(() => iterator()), map(data => Array.from(data)), shareReplay(1));
    }
}
//# sourceMappingURL=observable_map.js.map